<template>
    <el-dialog
        title="绑定微信"
        :visible.sync="wxDialogVisible"
        width="30%"
        :center="true"
        :append-to-body="true"
        class="dialog_wx"
        :close-on-click-modal="false"
        :before-close="() => closewxDialog()"
    >
        <div class="div_new_image">
            <img v-if="tt" :src="wx_url" class="wx_qr_code" />
            <img v-else src="../../../assets/img/login/login_avatar.gif" class="wx_qr_code" />
        </div>
        <div class="msg" style="color:#FF0000">
            温馨提示：
        </div>
        <p class="msg">
            <span>如您未</span>
            <span class="guanzhu">关注</span>
            <span>公众号，扫码后请点击</span>
            <span class="guanzhu">关注</span>
            <span>。</span>
        </p>
        <p class="msg">
            <span class="guanzhu">关注</span><span>后会自动进行绑定，无需再次扫码。</span>
        </p>
        <p class="msg" style="color:#FF0000">
            二维码有效期倒计时：
        </p>
        <h1 class="tt">
            <span v-if="tt>0">{{tt}}秒</span>
            <span v-else>二维码已过期</span>
        </h1>

        <span slot="footer" class="dialog-footer">
            <el-button plain @click="closewxDialog()">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name:'wxDialogComponent',
    data(){
        return {
            tt: ''
        }
    },
    computed:{},
    methods:{
        closewxDialog() {
            this.$emit('exitwxDialog')
        },
    },
    filters:{},
    props:{
        wxDialogVisible: Boolean,
        wx_url: String,
        ftt: Number
    },
    created(){},
    destoryed(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{
        ftt(newVal) {
            this.tt = newVal
        }
    }
}
</script>

<style lang='less'>
.msg {
    text-align: center;
}
.guanzhu {
    color: #2828FF;
}
.tt {
    text-align: center;
    color: #8600FF;
}
</style>